import { render } from "./BaseButtonMenuSet.vue?vue&type=template&id=c9999b1a&scoped=true"
import script from "./BaseButtonMenuSet.vue?vue&type=script&lang=js"
export * from "./BaseButtonMenuSet.vue?vue&type=script&lang=js"

import "./BaseButtonMenuSet.vue?vue&type=style&index=0&id=c9999b1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9999b1a"]])

export default __exports__